import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, formatApiErrorDetail } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        // No session yet or /auth/me expired — treat as guest.
        setUser(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // Logout is best-effort — cookie may already be invalid server-side.
    }
    setUser(false);
  };

  const value = useMemo(
    () => ({ user, error, login, logout, setUser }),
    // login/logout are stable enough for this app; user/error drive re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user, error]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
